import RequestMaster from '../RequestMaster'

export default class RequestCondicionColegio extends RequestMaster {

    constructor() {
        super()
        this.URL_BASE = this.URL_BASE + '/colegio/condicion'
    }
}
